import { get } from './requests'

export const getDaasClients = (fields) => get(['daas-clients'], {}, { fields })
